import { render } from "./FormUserManagement.vue?vue&type=template&id=87470c40"
import script from "./FormUserManagement.vue?vue&type=script&lang=js"
export * from "./FormUserManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__